import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Header from "../Component/Header";
import Footer from "../Component/Footer";

const tabs = [
  "PT-1",
  "PT-2",
  "Half Yearly Examination",
  "PT-3",
  "Annual Examination",
];

const CLASS_RANK = {
  class6: 0,
  classvi: 0,
  class7: 1,
  classvii: 1,
  class8: 2,
  classviii: 2,
};

function classRank(label) {
  const key = String(label).toLowerCase().replace(/[^a-z0-9]/g, "");
  return CLASS_RANK[key] ?? 99;
}

function sortByClass(items) {
  return [...items].sort((a, b) => classRank(a.classLabel) - classRank(b.classLabel));
}

const syllabusByTab = {
  "PT-1": [],
  "PT-2": [],
  "Half Yearly Examination": [
    {
      classLabel: "Class 6",
      fileName: "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/STPSFH/public/pdf/syllabus/Middle_Stage/PT_1/VI_Term_1_Syllabus.pdf",
    },
    {
      classLabel: "Class 7",
      fileName:
        "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/STPSFH/public/pdf/syllabus/Middle_Stage/Half_yearly/Class_7_half_yearly_syllabus.pdf",
    },
    {
      classLabel: "Class 8",
      fileName:
        "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/STPSFH/public/pdf/syllabus/Middle_Stage/Half_yearly/CLASS_8_Half_Yearly_syllabus.pdf",
    },
  ],
  "PT-3": [],
  "Annual Examination": [],
};

function pdfHref(fileName) {
  return encodeURI(`${fileName}`);
}

function MiddleStage() {
  const [tab, setTab] = useState("PT-1");
  const syllabusItems = sortByClass(syllabusByTab[tab] || []);

  useEffect(() => {
    document.title =
      "Middle Stage (VI–VIII) - St Peters Convent School Faridabad Haryana";
  }, []);

  return (
    <>
      <Header />
      <div className="innerslide">
        <ul className="breadcrumb">
          <li>
            <Link to="/">Home</Link>
          </li>
          <li>Academics</li>
          <li>Syllabus</li>
          <li>Middle Stage (VI–VIII)</li>
        </ul>
      </div>

      <div className="innersec">
        <div className="container">
          <div className="row mb-4">
            <div className="col-12">
              <h1 className="fw-bold">Middle Stage (VI–VIII)</h1>
            </div>
          </div>

          <nav>
            <div className="nav nav-tabs" role="tablist">
              {tabs.map((name) => (
                <button
                  key={name}
                  type="button"
                  role="tab"
                  className={`nav-link${tab === name ? " active" : ""}`}
                  aria-selected={tab === name}
                  onClick={() => setTab(name)}
                >
                  {name}
                </button>
              ))}
            </div>
          </nav>

          <div className="row mt-4">
            {syllabusItems.map((item) => (
              <div className="col-lg-3 col-md-6 mb-4" key={item.fileName}>
                <div className="card syllabus-card h-100 text-center">
                  <div className="card-body">
                    <div className="pdf-icon mb-3">📄</div>
                    <h6 className="fw-semibold">{item.classLabel}</h6>
                    <a
                      href={pdfHref(item.fileName)}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="click-text"
                    >
                      Click Here →
                    </a>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}

export default MiddleStage;
